import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'

import Comp from '../component'

export type Props = BaseReactProps & {

  withThumbIndicator: boolean
  inGroup: boolean
  checkedThumbIcon?: string
  notCheckedThumbIcon?: string
  checkedThumbColor?: string
  notCheckedThumbColor?: string
  thumbIcon?: boolean
  checkedState: boolean
  disabled?: boolean
  label?: string
  labelPosition?: 'left' | 'right'
  size: string
  radius: string
  color: string
  description?: string
}

export default {
  hashTag: '#pre-release',
  module: { static: Comp },
  inNode: {
    inputs: [
      getPortDef({ name: 'label', displayName: 'Label', group: 'Params', type: 'string', }),
      getPortDef({ name: 'description', displayName: 'Description', group: 'Params', type: 'string', }),
      
      getPortDef({ name: 'inGroup', displayName: 'In SwitchGroup', group: 'Params', type: 'boolean', default: false }),
      getPortDef({ name: 'value', displayName: 'Value', group: 'Params', type: 'string', dependsOn: (p: Props) => p.inGroup }),
      getPortDef({
        name: 'withThumbIndicator',
        displayName: 'With Thumb Indicator',
        group: 'States',
        type: 'boolean',
        default: false,
      }),
      getPortDef({
        name: 'checkedThumbIcon',
        displayName: 'Checked Thumb Icon',
        group: 'Custom',
        customGroup: 'Icon',
        type: 'string',
        default: '',
        dependsOn: (p: Props) => p.withThumbIndicator
      }),
      getPortDef({
        name: 'checkedThumbColor',
        displayName: 'Checked thumb color',
        group: 'Custom',
        customGroup: 'Icon',
        type: 'string',
        default: 'green',
        dependsOn: (p: Props) => p.withThumbIndicator
      }),
      getPortDef({
        name: 'notCheckedThumbIcon',
        displayName: 'Not Checked Thumb Icon',
        group: 'Custom',
        customGroup: 'Icon',
        type: 'string',
        default: '',
        dependsOn: (p: Props) => p.withThumbIndicator
      }),
      getPortDef({
        name: 'notCheckedThumbColor',
        displayName: 'Not checked thumb color',
        group: 'Custom',
        customGroup: 'Icon',
        type: 'string',
        default: 'red',
        dependsOn: (p: Props) => p.withThumbIndicator
      }),
      getPortDef({
        name: 'checkedState',
        displayName: 'Checked',
        group: 'States',
        type: 'boolean',
        default: false,
        dependsOn: (p: Props) => !p.inGroup,
      }),
      getPortDef({
        name: 'disabled',
        displayName: 'Disabled',
        group: 'States',
        type: 'boolean',
        default: false,
      }),
      getPortDef({
        name: 'labelPosition',
        displayName: 'Label position',
        group: 'Layout',
        type: [
          { value: 'right', label: 'Right' },
          { value: 'left', label: 'Left' },
        ],
        default: 'right',
      }),
      getPortDef({
        name: 'size',
        displayName: 'Size',
        group: 'Dimensions',
        type: sizes,
        default: 'sm',
      }),
      getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
      getPortDef({
        name: 'color',
        displayName: 'Color',
        group: 'Styles',
        type: 'string',
        default: 'blue',
      }),
      getPortDef({
        name: 'radius',
        displayName: 'Radius',
        group: 'Styles',
        type: sizes,
        default: 'lg',
      }),
    ],
    outputs: [
      getPortDef({
        name: 'checked',
        displayName: 'Checked',
        group: 'States',
        type: 'boolean',
      }),
      getPortDef({
        name: 'changed',
        displayName: 'Changed',
        group: 'Signals',
        type: 'signal',
      }),
    ],
  },
} satisfies ReactNodeDef
